/**
 * @generated SignedSource<<0c45560e35a412dd7fd518b3d064b669>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type BulkOperationsWrapper$data = {
  readonly totalIssueSearchResultCount?: number | null | undefined;
  readonly " $fragmentType": "BulkOperationsWrapper";
};
export type BulkOperationsWrapper$key = {
  readonly " $data"?: BulkOperationsWrapper$data;
  readonly " $fragmentSpreads": FragmentRefs<"BulkOperationsWrapper">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcbulkopsselectallrelayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "BulkOperationsWrapper",
  "selections": [
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcbulkopsselectallrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "totalIssueSearchResultCount"
        }
      ]
    }
  ],
  "type": "JiraIssueConnection"
};

(node as any).hash = "6b27d39e5a7bf796e3e7def05054ed18";

export default node;
